import { carouselItems } from './mockData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 mb-4">
              <i className="ri-focus-2-line text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">深度专题</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              深度策划的影视专题内容，带你发现更多精彩
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
              >
                <div className="relative h-48 md:h-56 overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}